import { SELECIONAR_REPASSE } from '../../actions/types'

const initialState = undefined
const estadoInicial = {}

export default function reducerRepasseVendaSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_REPASSE: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}